<yc-alert *ngIf="logicAsSentence"
  alertClass="info"
  [message]="logicAsSentence">
</yc-alert>